export { TextAtom, type TextAtomProps } from "./TextAtom";
